module.exports = __webpack_public_path__ + "img/specialist_black_icon.3a5cc1c5.svg";